"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = exports.SearchInput = exports.SearchContainer = void 0;
const tslib_1 = require("tslib");
const theme_1 = require("@monorepo/theme");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const __1 = require("..");
exports.SearchContainer = styled_components_1.default.div `
  position: relative;
`;
exports.SearchInput = styled_components_1.default.input `
  width: ${({ width }) => width !== null && width !== void 0 ? width : 170}px;
  height: ${({ height }) => height !== null && height !== void 0 ? height : 30}px;
  background-color: ${({ backgroundColor }) => backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme_1.colors.lighterGrey};
  border-radius: 28px;
  border: none;
  color: ${theme_1.colors.black};
  outline: none;
  padding: 0 15px 0 35px;

  &::placeholder {
    color: ${theme_1.colors.slateGrey};
  }
`;
exports.StyledIcon = (0, styled_components_1.default)(__1.Icon) `
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  line-height: 0;
`;
